"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var core = {
  MODE: {
    EDIT: "Edit",
    VIEW: "View"
  },
  SLD_ICON_TYPES: {
    LABEL: "label",
    ISOLATER: "isolator",
    FUSE: "fuse",
    RELAY: "relay",
    BREAKER: "breaker",
    BUSBAR: "busbar",
    FEEDER: "feeder",
    INCOMING_FEEDER: "incomingFeeder",
    OUTGOING_FEEDER: "outgoingFeeder",
    FEEDER_JUNCTION: "feederJunction",
    TRANSFORMER: "transformer",
    TRANSDUCER: "transducer",
    BATTERY: "battery",
    MOTOR: "motor",
    GRID: "grid"
  },
  BREAKER_TYPE: {
    SINGLE_POINT: 'Single Point',
    DOUBLE_POINT: 'Double Point'
  },
  ASSET_PREFIX: 'Ast',
  // id prefix of each component that gets generated
  HEADER_OFFSET: 85,
  ROOT_SIZE: 1,
  sidebarAdjustment: 160,
  // px
  SNAP_PIXELS: 50,
  // snap to grid size in pixels
  imagePrefix: "/Images/IEEE1975/",
  sizeOfElements: {
    width: 50,
    height: 50,
    unit: 'px'
  } // size of each element in pixels

};
var _default = core;
exports.default = _default;